import sortBy from "lodash/sortBy";
import { handleActions } from "redux-actions";

import { reorder } from "utils/array";
import removeById from "utils/removeById";

const updatePicture = (pictures, picture) =>
  pictures.map((p) => {
    if (p.id === picture.id) return { ...p, ...picture };
    if (p.isPrimary && picture.isPrimary) return { ...p, isPrimary: false };
    if (p.isHeader && picture.isHeader) return { ...p, isHeader: false };

    return { ...p };
  });

export default handleActions(
  {
    ASSET_PICTURES_GET: {
      PENDING: () => ({
        assetPictures: [],
      }),
      FULFILLED: (_, { payload }) => ({
        assetPictures: sortBy(payload.pictures, ["position"]),
      }),
    },

    ASSET_PICTURE_CREATE: {
      PENDING: ({ assetPictures }, { meta: { photo } }) => ({
        assetPictures: [
          ...assetPictures,
          { isUploading: true, name: photo.name, type: photo.type },
        ],
      }),

      REJECTED: ({ assetPictures }, { meta: { photo } }) => ({
        assetPictures: assetPictures.map((picture) => {
          if (picture.name === photo.name && picture.isUploading) {
            return { ...picture, error: true };
          }

          return { ...picture };
        }),
      }),

      FULFILLED: ({ assetPictures }, { meta: { photo }, payload: { picture } }) => ({
        assetPictures: assetPictures.map((p) => {
          if (photo.name === p.name && p.isUploading) {
            return { ...p, ...picture, isUploading: false };
          }

          return { ...p };
        }),
      }),
    },

    ASSET_PICTURE_UPDATE: {
      FULFILLED: ({ assetPictures }, { payload: { picture } }) => ({
        assetPictures: updatePicture(assetPictures, picture),
      }),
    },

    ASSET_PICTURE_DELETE: {
      PENDING: ({ assetPictures }, { meta: { pictureID } }) => ({
        assetPictures: removeById(assetPictures, pictureID),
      }),
    },

    ASSET_PICTURE_REORDER: ({ assetPictures }, { meta: { newIndex, oldIndex } }) => ({
      assetPictures: reorder(assetPictures, oldIndex, newIndex),
    }),
  },
  {},
  { namespace: "_" }
);
